export class GmMatColumnDef extends String {
  header: string;
  display: boolean;
  lock: boolean;
  index: number;
  tooltip: string;
  type: string; //text, bool, multiselect
  field: string;
  constructor(field, header, display, lock, index, tooltip, type) {
    super(field);
    this.field = field;
    this.header = header;
    this.display = display;
    this.lock = lock;
    this.index = index;
    this.tooltip = tooltip;
    this.type = type;
  }
}
